module.exports = __webpack_public_path__ + "static/img/0402_08.c76a0f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_08.png
// module id = MHZH
// module chunks = 1